<button cs-capture-cover [disabled]="disabled" [attr.aria-label]="ariaLabel || null"></button>
@if (icon) {
  <cs-icon [name]="icon"></cs-icon>
}
<!-- The label and its description are wrapped together so they stay one block under the
     icon, whatever else the host arranges around them. With no description this wrapper holds a
     single line and looks exactly like the bare label it replaced. -->
<span class="bar-button-text">
  <span class="bar-button-label">{{ label }}</span>
  @if (description) {
    <span class="bar-button-description">{{ description }}</span>
  }
</span>
